import { KeycloakTokenParsed } from 'keycloak-js/lib/keycloak';
import { Authorities } from '../enums/authorities.enum';
import { Modules } from '../enums/modules.enum';
import { PrivilegedRole } from '../enums/privileged-roles.enum';

export class User {
  name!: string;
  firstName!: string;
  lastName!: string;
  authorities!: Authorities[];
  roles!: PrivilegedRole[];
  modules!: Modules[];
  email!: string;
  userId!: string;
  customerId!: string;
  partnerId!: string;
  organisations!: string[];


  constructor(token: KeycloakTokenParsed) {
    this.updateUser(token);
  }

  public updateUser(token: KeycloakTokenParsed) {
    this.name = token?.['name'];
    this.authorities = <Authorities[]>token?.realm_access?.roles;
    this.roles = token?.['groups'];
    this.modules = token?.['modules'];
    this.firstName = token?.['given_name'];
    this.lastName = token?.['family_name'];
    this.email = token?.['email'];
    this.userId = token?.['userId'];
    this.customerId = token?.['customerId'];
    this.partnerId = token?.['partnerId'];
    this.organisations = token?.['organisations'];
  }
}

